/* ============================================
   THEME JS — Component initialization
   ============================================ */

/* Quantity picker */
class QuantityPicker extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('.quantity-picker__input');
    this.btnMinus = this.querySelector('[data-action="minus"]');
    this.btnPlus = this.querySelector('[data-action="plus"]');
    this.min = parseInt(this.input.min) || 1;
    this.max = parseInt(this.input.max) || 99;

    this.btnMinus.addEventListener('click', () => this.adjust(-1));
    this.btnPlus.addEventListener('click', () => this.adjust(1));
    this.input.addEventListener('change', () => this.validate());
  }

  adjust(delta) {
    const current = parseInt(this.input.value) || this.min;
    const newVal = Math.min(Math.max(current + delta, this.min), this.max);
    this.input.value = newVal;
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  validate() {
    let val = parseInt(this.input.value);
    if (isNaN(val) || val < this.min) val = this.min;
    if (val > this.max) val = this.max;
    this.input.value = val;
  }
}

if (!customElements.get('quantity-picker')) {
  customElements.define('quantity-picker', QuantityPicker);
}

/* Product form — AJAX add to cart */
class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.submitButton = this.querySelector('[type="submit"]');
    this.form.addEventListener('submit', (e) => this.onSubmit(e));
  }

  async onSubmit(e) {
    e.preventDefault();

    this.submitButton.setAttribute('disabled', '');
    this.submitButton.classList.add('loading');

    const formData = new FormData(this.form);
    const items = [{
      id: parseInt(formData.get('id')),
      quantity: parseInt(formData.get('quantity')) || 1
    }];

    try {
      await CartAPI.add(items);

      if (document.querySelector('cart-drawer')) {
        PubSub.publish('cart:open');
      }
    } catch (error) {
      console.error('Add to cart error:', error);
    } finally {
      this.submitButton.removeAttribute('disabled');
      this.submitButton.classList.remove('loading');
    }
  }
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', ProductForm);
}
